import * as React from 'react';
import { observer } from 'mobx-react';
import { ExperienceResource } from '../Types';
import { T } from '../../../../../../../Translations';

export interface Props {
  resource: ExperienceResource;
}

const OfferedBy: React.FC<Props> = ({ resource }) =>
  resource.payload.schoolPartnerLogoUrl
    .map((url) => (
      <div className="flex flex-col px-10">
        <div className="mb-2 text-sm font-medium">
          <T kind="Offered by" />
        </div>
        <img className="w-2/5 max-w-[288px]" src={url} alt={resource.payload.schoolPartnerName} />
      </div>
    ))
    .getOrElse(() => <></>);

export default observer(OfferedBy);
